// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  bountyId: __t.u64().primaryKey().name("bounty_id"),
  target: __t.identity(),
  placedBy: __t.identity().name("placed_by"),
  reward: __t.i64(),
  fee: __t.i64(),
  note: __t.string(),
  state: __t.string(),
  claimedBy: __t.identity().name("claimed_by"),
  placedAt: __t.timestamp().name("placed_at"),
  expiresAt: __t.timestamp().name("expires_at"),
  resolvedAt: __t.timestamp().name("resolved_at"),
});
